import { useEffect, useState } from 'react'
import { API_URL, getClassNameForField, projectFields as fields } from '../../constants'
import { EditableFormPage } from '../components/EditableFormPage'
import { useParams } from 'react-router-dom'
import { Button } from '../../shared/components/Button'
import { FaEye, FaTrash } from 'react-icons/fa'
import { FaEyeSlash } from 'react-icons/fa6'
import { useDeleteItem } from '../../util/deleteItem'
import ConfirmDeleteModal from '../components/DeleteModal'
import ProjectSlug from '../../public/pages/ProjectSlug'
import { useTranslation } from 'react-i18next'
import { useTranslationService } from '../../util/TranslationContext'
import { languageUtil } from '../../util/languageUtils'

const ProjectsSlugAdmin = () => {
    const [showConfirm, setShowConfirm] = useState(false)
    const [options, setOptions] = useState([])

    const { translateFields } = useTranslationService()
    const projectFields = translateFields(fields, 'projects')
    const { language } = languageUtil()

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const token = localStorage.getItem('token')
                const response = await fetch(`${API_URL}/admin/project-categories`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Accept-Language': language,
                    },
                })
                const result = await response.json()

                // Assuming response.data.data is the array of categories
                const mappedOptions = result.data.map(item => ({
                    label: item.title,
                    value: item.id,
                }))
                setOptions(mappedOptions)
            } catch (error) {
                console.error('Error fetching options:', error)
            }
        }

        fetchOptions()
    }, [language])

    const { id } = useParams()
    const { t } = useTranslation()

    const deleteItem = useDeleteItem()
    const handleDelete = async () => {
        await deleteItem({
            url: `admin/projects/${id}`,
            navigateSuccess: '/admin/auth/projects',
            onError: msg => alert(msg),
        })
    }

    return (
        <>
            <div className='flex items-center justify-between'>
                <Button
                    variant='primary'
                    className='mb-4'
                    onClick={() => window.open(`/projects/${id}`, '_blank', 'noopener,noreferrer')}
                >
                    <FaEye /> {t('status.preview')}
                </Button>
                <Button variant='danger' className='mb-4' onClick={() => setShowConfirm(true)}>
                    <FaTrash />
                    {t('status.delete')}
                </Button>

                <ConfirmDeleteModal
                    isOpen={showConfirm}
                    onClose={() => setShowConfirm(false)}
                    onConfirm={handleDelete}
                    title='Delete this project?'
                    description='This action cannot be undone. Are you sure you want to delete this project?'
                />
            </div>
            <EditableFormPage
                title='Project Details'
                fetchUrl={`admin/projects/${id}?_method=PUT`}
                fields={projectFields}
                classNameForField={getClassNameForField}
                loadingMessage='Loading project information...'
                errorMessage='Failed to fetch project data.'
                options={options}
            />
        </>
    )
}

export default ProjectsSlugAdmin
